<!--
 * @Description: 项目总览
 * @Date: 2024-01-11 13:52:40
-->
<template>
  <div class="bi-tmpl-detail__right__cmpt">
    <div>
      <span v-if="curItem.tips" class="bi-tmpl-detail__right__cmpt__tips">
        {{ curItem.tips }}
      </span>
    </div>
    <Carousel ref="carouselRef" :itemHeight="675" :itemWidth="420 + 56">
      <div v-for="(item, index) in TYPE_MAPPING" :key="index">
        <div
          class="xrk-card"
          @click="onChange(item.value)"
          style="width: 420px; height: 700px"
        >
          <div
            :style="{
              width: '100%',
              height: '700px',
              'border-radius': '2px',
              position: 'absolute',
              top: '0',
              left: '0',
              boxSizing: 'border-box',
              padding: '0 20px'
            }"
          >
            <component
              :is="titleCmpt"
              style="
                width: 1200px;
                transform: scale(0.33);
                transform-origin: 0 center;
              "
              v-bind="{
                innerText: '项目总览',
                enInnerText: 'Project Overview'
              }"
            />

            <component :is="cmpName(item.value)" />

            <component
              style="width: 60px; height: 30px"
              v-if="pageNoCmpt"
              :is="pageNoCmpt"
            />
          </div>
        </div>
        <div class="bi-tmpl-detail__right__cmpt__radioBox">
          <BaseRadio
            :value="item.value"
            :model-value="curItem.value"
            @click="onChange(item.value)"
          >
            {{}}
          </BaseRadio>
        </div>
      </div>
    </Carousel>
  </div>
</template>

<script lang="ts" setup>
import { BaseRadio } from 'xrk-components';
import { Carousel } from '@/components/base/carousel';
import PcModuleOverview from '../bi-pc-module/pc-module-overview/index';

import { useDetailCmpt } from '@V/bi-tmpl/src/hooks';

const TYPE_MAPPING = [1, 2, 3, 4].map(i => {
  return {
    value: 'pc-module-overview-' + i,
    index: i
  };
});

const cmpName = name => {
  return PcModuleOverview.filter(comp => comp.__name === name)[0];
};

const { curItem, onChange, titleCmpt, pageNoCmpt } = useDetailCmpt({});
</script>
<style lang="scss" scope></style>
